import React from 'react'
import { Icon, IconName } from '~components/Icon'
import * as Styled from './Pagination.styles'

export interface PaginationProps {
  /**
   * First button callback
   */
  onGoToFirst: () => Promise<void> | void
  /**
   * Last button callback
   */
  onGoToLast: () => Promise<void> | void
  /**
   * Prev button callback
   */
  onPrevClick: () => Promise<void> | void
  /**
   * Next button callback
   */
  onNextClick: () => Promise<void> | void
  /**
   * Has next page?
   */
  hasNextPage: boolean
  /**
   * Has previous page?
   */
  hasPrevPage: boolean
  /**
   * Can go to first page?
   */
  canGoToFirst?: boolean
  /**
   * Can go to last page?
   */
  canGoToLast?: boolean
  /**
   * Current page number
   */
  pageIndex?: number
  /**
   * Total pages
   */
  totalPages?: number
  /**
   * Has disabled state?
   */
  isDisabled?: boolean
  /**
   * Title to use for 'First' button
   */
  firstButtonTitle?: string
  /**
   * Title to use for 'Last' button
   */
  lastButtonTitle?: string
}

const CursorPagination: React.FC<PaginationProps> = ({
  totalPages,
  onGoToFirst,
  onPrevClick,
  onNextClick,
  onGoToLast,
  isDisabled,
  pageIndex,
  hasPrevPage,
  hasNextPage,
  canGoToFirst = false,
  canGoToLast = false,
  firstButtonTitle = 'First',
  lastButtonTitle = 'Last',
}) => {
  const pageInfo =
    pageIndex !== undefined && !!totalPages ? (
      <>
        {pageIndex + 1} / {totalPages + 1}
      </>
    ) : null
  const isFirstPageDisabled = pageInfo ? pageIndex === 0 : !canGoToFirst
  const isLastPageDisabled = pageInfo ? pageIndex === totalPages : !canGoToLast

  return (
    <Styled.Container>
      <Styled.List>
        <Styled.DirectionButton onClick={() => onGoToFirst()} disabled={isDisabled || isFirstPageDisabled}>
          {firstButtonTitle}
        </Styled.DirectionButton>
        <Styled.PageButton onClick={() => onPrevClick()} disabled={isDisabled || !hasPrevPage}>
          <Icon name={IconName.chevron_left} />
        </Styled.PageButton>

        <Styled.PageInfo>{pageInfo}</Styled.PageInfo>

        <Styled.PageButton onClick={() => onNextClick()} disabled={isDisabled || !hasNextPage}>
          <Icon name={IconName.chevron_right} />
        </Styled.PageButton>
        <Styled.DirectionButton onClick={() => onGoToLast()} disabled={isDisabled || isLastPageDisabled}>
          {lastButtonTitle}
        </Styled.DirectionButton>
      </Styled.List>
    </Styled.Container>
  )
}

CursorPagination.displayName = 'CursorPagination'
export default CursorPagination
